import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { categories, mainSiteUrl, seoKeywords } from '@/mocks/categories';
import { SITE_URL } from '@/constants';

const siteUrl = SITE_URL;
const articleUrl = `${siteUrl}/itaobuy-spreadsheet-guida-acquisti`;

const guidaAcquistiJsonLd = {
  "@context": "https://schema.org",
  "@type": "Article",
  "headline": "Guida Acquisti Itaobuy Sheet 2026: Come Comprare in Sicurezza",
  "description": "Tutto quello che devi sapere per acquistare in sicurezza su Itaobuy Sheet. Metodi di pagamento, spedizione, resi e consigli per ogni categoria prodotto.",
  "image": "https://readdy.ai/api/search-image?query=Online%20shopping%20concept%20with%20credit%20card%20and%20fashion%20items%20on%20warm%20wooden%20desk%2C%20soft%20natural%20daylight%2C%20minimalist%20editorial%20photography%2C%20European%20aesthetic%2C%20warm%20neutral%20tones%2C%20no%20text%20no%20logos%2C%20clean%20composition%2C%20shopping%20bags%20and%20product%20packages%20nearby&width=800&height=600&seq=guida-acquisti-hero&orientation=landscape",
  "datePublished": "2026-07-14",
  "dateModified": "2026-07-14",
  "author": {
    "@type": "Organization",
    "name": "Itaobuy Spreadsheet Italia"
  },
  "publisher": {
    "@type": "Organization",
    "name": "Itaobuy Spreadsheet Italia",
    "logo": {
      "@type": "ImageObject",
      "url": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/62f99c0415358bd5388d5ed1df9ac1ff.jpeg"
    }
  },
  "url": articleUrl,
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": articleUrl
  },
  "inLanguage": "it"
};

export default function GuidaAcquistiPage() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(guidaAcquistiJsonLd)
        }}
      />
      <nav className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-background-100">
        <div className="w-full px-6 md:px-10 lg:px-16">
          <div className="flex items-center justify-between h-16 md:h-20">
            <a href="/" className="font-heading text-xl md:text-2xl font-semibold text-foreground-950 tracking-tight hover:opacity-80 transition-opacity whitespace-nowrap">
              Itaobuy<span className="italic font-normal text-primary-500">Spreadsheet</span>
            </a>
            <div className="hidden md:flex items-center gap-5">
              <a href="/" className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">Home</a>
              <a href="/itaobuy-spreadsheet-guida" className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">Guida</a>
              <a href="/itaobuy-spreadsheet-recensione" className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">Recensioni</a>
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="px-5 py-2 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">Buy It Now</a>
            </div>
          </div>
        </div>
      </nav>

      <section className="relative py-20 md:py-28 bg-background-50 overflow-hidden">
        <div className="w-full px-6 md:px-10 lg:px-16 max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
            <div className="flex-1">
              <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-6" aria-label="Breadcrumb">
                <a href="/" className="hover:text-primary-500 transition-colors">Home</a>
                <span className="w-4 h-4 flex items-center justify-center">/</span>
                <span className="text-foreground-400">Guida Acquisti</span>
              </nav>
              <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-semibold text-foreground-950 leading-tight mb-6">
                Guida Acquisti{' '}
                <span className="italic text-primary-500">Itaobuy Sheet 2026</span>
              </h1>
              <div className="flex items-center gap-3 text-sm text-foreground-500 mb-6">
                <i className="ri-calendar-line w-4 h-4 flex items-center justify-center"></i>
                <span>Aggiornato: Luglio 2026</span>
                <span className="text-foreground-300">|</span>
                <i className="ri-time-line w-4 h-4 flex items-center justify-center"></i>
                <span>8 minuti di lettura</span>
              </div>
              <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-8 max-w-xl">
                Tutto quello che devi sapere per acquistare in sicurezza su Itaobuy Sheet.
                Metodi di pagamento, spedizione, resi e consigli per ogni categoria prodotto.
              </p>
              <button onClick={() => navigate('/')} className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-950 text-white rounded-full text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center"></i>
                Torna alla Home
              </button>
            </div>
            <div className="flex-1">
              <div className="rounded-2xl overflow-hidden">
                <img src="https://readdy.ai/api/search-image?query=Online%20shopping%20concept%20with%20credit%20card%20and%20fashion%20items%20on%20warm%20wooden%20desk%2C%20soft%20natural%20daylight%2C%20minimalist%20editorial%20photography%2C%20European%20aesthetic%2C%20warm%20neutral%20tones%2C%20no%20text%20no%20logos%2C%20clean%20composition%2C%20shopping%20bags%20and%20product%20packages%20nearby&width=800&height=600&seq=guida-acquisti-hero&orientation=landscape" className="w-full h-full object-cover" alt="Guida Acquisti Itaobuy Sheet" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-white">
        <div className="w-full px-6 md:px-10 lg:px-16 max-w-4xl mx-auto">
          <article className="space-y-16">
            <div>
              <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mb-6">1. Come Acquistare su Itaobuy Sheet</h2>
              <div className="space-y-4 text-foreground-700 leading-relaxed">
                <p>Acquistare su <strong>Itaobuy Sheet</strong> è semplice e sicuro. Visita il <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-primary-500 hover:text-primary-600 font-medium">sito ufficiale</a>, sfoglia le categorie prodotto disponibili e aggiungi gli articoli che ti interessano al carrello. La piattaforma accetta diversi metodi di pagamento tra cui carte di credito, PayPal e bonifico bancario.</p>
                <p>Prima di finalizzare l&apos;ordine, verifica sempre la disponibilità del prodotto, i tempi di spedizione stimati e le eventuali spese aggiuntive. Per maggiori dettagli sulle singole categorie, consulta la nostra <a href="/itaobuy-spreadsheet-guida" className="text-primary-500 hover:text-primary-600 font-medium">guida completa</a>.</p>
              </div>
            </div>

            <div>
              <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mb-6">2. Metodi di Pagamento Sicuri</h2>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mb-8">
                {[{ icon: 'ri-bank-card-line', title: 'Carte di Credito', desc: 'Visa, Mastercard, American Express accettate con protezione antifrode integrata.' }, { icon: 'ri-paypal-line', title: 'PayPal', desc: 'Pagamento rapido e sicuro con protezione acquirente PayPal inclusa.' }, { icon: 'ri-bank-line', title: 'Bonifico', desc: 'Disponibile per ordini superiori a 100 euro con conferma in 24-48 ore.' }].map((item, idx) => (
                  <div key={idx} className="p-6 rounded-xl bg-background-50 border border-background-200/70 text-center">
                    <div className="w-12 h-12 rounded-xl bg-teal-50 flex items-center justify-center text-teal-500 mx-auto mb-4">
                      <i className={`${item.icon} w-5 h-5 flex items-center justify-center`}></i>
                    </div>
                    <h4 className="font-heading text-base font-semibold text-foreground-900 mb-2">{item.title}</h4>
                    <p className="text-sm text-foreground-600">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mb-6">3. Categorie e Prodotti Disponibili</h2>
              <div className="space-y-4 text-foreground-700 leading-relaxed">
                <p><strong>Itaobuy Sheet</strong> offre una vasta gamma di categorie prodotto. Ecco le principali:</p>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mt-4">
                {categories.map((cat) => (
                  <a key={cat.id} href={cat.url} target="_blank" rel="noopener nofollow" className="flex items-center gap-3 px-4 py-3 rounded-xl border border-background-200/70 hover:border-primary-300 hover:bg-background-50 transition-all cursor-pointer">
                    <div className="w-8 h-8 rounded-lg bg-teal-50 flex items-center justify-center text-teal-500 flex-shrink-0">
                      <i className="ri-shopping-bag-line w-4 h-4 flex items-center justify-center"></i>
                    </div>
                    <span className="text-sm font-medium text-foreground-700">{cat.name}</span>
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mb-6">4. Resi e Garanzie</h2>
              <div className="space-y-4 text-foreground-700 leading-relaxed">
                <p>Ogni acquisto su <strong>Itaobuy Sheet</strong> è coperto da una garanzia di rimborso. Se il prodotto non corrisponde alla descrizione o presenta difetti, puoi richiedere un reso entro 14 giorni dalla consegna. Il processo è gestito direttamente tramite la piattaforma e il rimborso viene elaborato entro 5-7 giorni lavorativi.</p>
                <p>Per approfondire gli aspetti di sicurezza, consulta la nostra <a href="/itaobuy-spreadsheet-sicurezza" className="text-primary-500 hover:text-primary-600 font-medium">guida alla sicurezza</a>. Per conoscere le opinioni degli altri acquirenti, leggi la <a href="/itaobuy-spreadsheet-recensione" className="text-primary-500 hover:text-primary-600 font-medium">recensione completa</a>.</p>
              </div>
            </div>
          </article>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-background-50">
        <div className="w-full px-6 md:px-10 lg:px-16 max-w-7xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-950 mb-12">Articoli Correlati</h2>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
            {[{ title: 'Guida Completa 2026', url: '/itaobuy-spreadsheet-guida', icon: 'ri-book-open-line' }, { title: 'Recensione Dettagliata', url: '/itaobuy-spreadsheet-recensione', icon: 'ri-star-line' }, { title: 'Sicurezza e Privacy', url: '/itaobuy-spreadsheet-sicurezza', icon: 'ri-shield-check-line' }].map((item, i) => (
              <a key={i} href={item.url} className="p-6 rounded-xl bg-white border border-background-200/70 hover:shadow-md transition-all group cursor-pointer">
                <div className="w-12 h-12 rounded-xl bg-teal-50 flex items-center justify-center text-teal-500 mx-auto mb-4 group-hover:bg-teal-100 transition-colors">
                  <i className={`${item.icon} w-5 h-5 flex items-center justify-center`}></i>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-teal-500 transition-colors">{item.title}</h3>
              </a>
            ))}
          </div>
        </div>
      </section>

      <section className="py-12 bg-background-50">
        <div className="w-full px-6 md:px-10 lg:px-16 max-w-4xl mx-auto text-center">
          <p className="text-foreground-500 text-sm mb-4">
            Torna alla homepage per esplorare tutte le guide e le risorse su
            <a href="/" className="text-primary-500 hover:text-primary-600 font-medium ml-1">Itaobuy Spreadsheet Italia</a>
          </p>
          <div className="flex flex-wrap items-center justify-center gap-2 text-xs text-foreground-400">
            {seoKeywords.map((kw, idx) => (
              <span key={idx} className="px-3 py-1 rounded-full bg-white border border-background-200">{kw}</span>
            ))}
          </div>
        </div>
      </section>

      <footer className="bg-accent-900 text-white">
        <div className="w-full px-6 md:px-10 lg:px-16 max-w-7xl mx-auto">
          <div className="py-12 grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <a href="/" className="font-heading text-2xl font-semibold text-white tracking-tight inline-block mb-4">Itaobuy<span className="italic font-normal text-accent-300">Spreadsheet</span></a>
              <p className="text-white/50 text-sm max-w-xs">La guida italiana più completa su Itaobuy Spreadsheet. Guide, recensioni, tutorial e confronti aggiornati.</p>
            </div>
            <div className="grid grid-cols-2 gap-6">
              <div className="flex flex-col gap-2">
                <a href="/" className="text-white/60 text-sm hover:text-white transition-colors">Home</a>
                <a href="/itaobuy-spreadsheet-guida" className="text-white/60 text-sm hover:text-white transition-colors">Guida Completa</a>
                <a href="/itaobuy-spreadsheet-guida-acquisti" className="text-white/60 text-sm hover:text-white transition-colors">Guida Acquisti</a>
              </div>
              <div className="flex flex-col gap-2">
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-white/60 text-sm hover:text-white transition-colors">Buy It Now</a>
                <a href="#" className="text-white/60 text-sm hover:text-white transition-colors">Privacy Policy</a>
                <a href="#" className="text-white/60 text-sm hover:text-white transition-colors">Cookie Policy</a>
              </div>
            </div>
          </div>
          <div className="py-5 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-white/40 text-xs">&copy; {new Date().getFullYear()} Itaobuy Spreadsheet Italia.</p>
            <div className="flex items-center gap-3">
              {['ri-facebook-line', 'ri-twitter-x-line', 'ri-instagram-line'].map((icon) => (
                <a key={icon} href="#" className="w-7 h-7 rounded-md border border-white/20 flex items-center justify-center text-white/50 hover:text-white hover:border-white/40 transition-colors">
                  <i className={`${icon} w-3 h-3 flex items-center justify-center`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </footer>
    </main>
  );
}